import React from "react";
import { createPortal } from "react-dom";
import { X } from "@phosphor-icons/react";

export default function BriefPopout({ open, onClose, title, badge, children }) {
  if (!open) return null;
  return createPortal(
    <div
      data-testid="brief-popout"
      className="fixed inset-0 z-[1300] bg-black/75 backdrop-blur-sm flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        className="w-full max-w-2xl max-h-[92vh] overflow-y-auto tac-scroll bg-tac-bg border border-tac-border rounded-sm shadow-2xl"
        onClick={(e) => e.stopPropagation()}
        style={{ zoom: 1.25 }}
      >
        <div className="sticky top-0 z-10 flex items-center justify-between gap-2 px-4 py-3 border-b border-tac-border bg-tac-bg">
          <div className="flex items-center gap-2 min-w-0">
            <span className="text-[13px] font-bold uppercase tracking-[0.15em] text-tac-text truncate">{title}</span>
            {badge}
          </div>
          <button
            type="button"
            data-testid="brief-popout-close"
            onClick={onClose}
            className="text-tac-dim hover:text-tac-text shrink-0"
          >
            <X size={18} weight="bold" />
          </button>
        </div>
        <div className="pt-3">{children}</div>
      </div>
    </div>,
    document.body
  );
}
